// PageHeaderBase component
/* eslint react/jsx-indent: 0, react/jsx-curly-newline: 0, react/jsx-closing-bracket-location: 0, indent: 0 */

import React, { Component } from 'react'
import classnames from 'classnames'

import IconButton from '../../common/icon_button/icon_button.jsx'
import IconButtonTheme from '../../../theme/common/icon_button/icon_button.jsx'
import Input from '../../form/input/input.jsx'
import FormDatePicker from '../../form/form_datepicker/form_datepicker.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import currency from '../../../lib/currency.jsx'
import ReportHeaderProjectTotal from '../../../report/header/report_header_projecttotal/report_header_projecttotal.jsx'
import ReportHeaderProjectStat from '../../../report/header/report_header_projectstat/report_header_projectstat.jsx'
import ReportHeaderProductivityTotal from '../../../report/header/report_header_productivitytotal/report_header_productivitytotal.jsx'
import ReportHeaderProjectGraph from '../../../report/header/report_header_projectgraph/report_header_projectgraph.jsx'
import ReportHeaderProductivityGraphV2 from '../../../report/header/report_header_productivitygraphv2/report_header_productivitygraphv2.jsx'
import ReportHeaderPlanner from '../../../report/header/report_header_planner/report_header_planner.jsx'
import ReportHeaderEmployeeProductivity from '../../../report/header/report_header_employeeproductivity/report_header_employeeproductivity.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import ProgressBar from '../../common/progress_bar/progress_bar.jsx'

class PageHeaderBase extends Component {
  static get propTypes () {
    return {}
  }

  static get defaultProps () {
    return {}
  }

  constructor (props) {
    super(props)

    this._escKeyListener = null
    this._message = null
    this._messageTime = null
  }

  componentDidMount () {
    this._escKeyListener = document.body.addEventListener(
      'keydown',
      this._onEscKey.bind(this)
    )
  }

  componentWillUnmount () {
    if (this._escKeyListener) {
      document.body.removeEventListener('keydown', this._onEscKey)
      this._escKeyListener = null
    }
  }

  render () {
    const _className = classnames('page-header', this.getClassName())
    return (
      <div className={_className}>
        {this._message && this.renderMessage()}
        <div className='content'>{this.renderContent()}</div>
      </div>
    )
  }

  renderMessage () {
    const message = this._message
    const info = message.info ? <IntlMessage ident={message.info} /> : ''
    return (
      <div
        className={`formmessage${
          !message.bSuccess ? ' formmessage_error' : ''
        }`}
      >
        <h2 className='title'>
          <IntlMessage ident={message.title} />
        </h2>
        <input style={{ opacity: 0 }} autoFocus />
        <p className='content'>{info}</p>
      </div>
    )
  }

  renderContent () {
    return null
  }

  getClassName () {
    return null
  }

  renderMainPanel (options) {
    const {
      title,
      titleTop,
      titleInfo,
      hasFilter,
      hasSearch,
      hasEdit,
      actions,
      onShowSearch,
      hasStatInfo,
      onShowFilter,
      onEdit,
      status,
      priceInfos,
      colType,
      hasObjectInfo,
      hasPriceInfo,
      statusLabel,
      actionPosition,
      bPriceInfoProgress,
      titleInfoClass
    } = options

    let statusClass = ''
    if (status) {
      statusClass = `item status status_${status.toLowerCase()}`
    }
    const _className = classnames(
      'headerpanel',
      {
        hasobjectinfo: hasObjectInfo,
        haspriceinfo: hasPriceInfo || (priceInfos && priceInfos.length > 0),
        hasstatinfo: hasStatInfo
      },
      colType
    )
    return (
      <div className={_className}>
        <div className='colleft'>
          {titleTop && (
            <div className='title titletop'>
              {titleTop && <h2 className='heading2'>{titleTop}</h2>}
            </div>
          )}
          <div className='title'>
            {title && (
              <h2 className='heading2' onClick={onShowSearch}>
                {title}
              </h2>
            )}
            {hasFilter && (
              <IconButton
                className='filterbutton filterlinebutton'
                size='normal'
                canHover={false}
                tooltip='common.list.tipFilterOpen'
                tooltipPosition='right'
                onClick={onShowFilter}
              >
                <span className='fline flinetop' />
                <span className='fline flinemiddle' />
                <span className='fline flinebottom' />
              </IconButton>
            )}
            {hasEdit && (
              <IconButton
                icon='header-edit'
                size='small'
                canHover={false}
                className='filterbutton filteredit'
                tooltip='common.list.tipEditDetails'
                tooltipPosition='top'
                onClick={onEdit}
              />
            )}
          </div>
          {(titleInfo || statusLabel) &&
            this.renderTitleInfo(
              titleInfo,
              status,
              statusLabel,
              statusClass,
              titleInfoClass
            )}
        </div>
        {(hasSearch ||
          actions.length > 0 ||
          (priceInfos && priceInfos.length > 0)) && (
          <div
            className={`colright${
              actionPosition ? ' action' + actionPosition : ''
            }`}
          >
            {actionPosition === 'left' &&
              this.renderPriceInfos(priceInfos, bPriceInfoProgress)}
            {(hasSearch || actions.length > 0) &&
              this.renderActionButtonGroup(hasSearch, onShowSearch, actions)}
            {actionPosition !== 'left' &&
              this.renderPriceInfos(priceInfos, bPriceInfoProgress)}
          </div>
        )}
      </div>
    )
  }

  renderClosedProjectMainPanel (options) {
    return (
      <div className='headerpanel closedproject'>
        <div className='col col1'>
          <ReportHeaderProjectTotal stat={options.info} />
        </div>
        <div className='col col2'>
          {this.renderMainPanel(options)}
          <div className='graph'>
            <ReportHeaderProjectGraph data={options.info} />
          </div>
        </div>
        <div className='col col3'>
          <ReportHeaderProjectStat
            stat={options.info}
            isPlannerAllowed={options.isPlannerAllowed}
          />
        </div>
      </div>
    )
  }

  renderPlannerMainPanel (options) {
    return (
      <div className='headerpanel planner'>
        <div className='col col1'>{this.renderMainPanel(options)}</div>
        <div className='col col2'>
          <ReportHeaderPlanner
            filterTypes={options.filterTypes}
            filterType={options.filterType}
            startMonth={options.startMonth}
            startWeekNo={options.startWeekNo}
            startDate={options.startDate}
            year={options.year}
            onChangeFilter={options.onChangeFilter} // eslint-disable-line react/jsx-handler-names
          />
        </div>
      </div>
    )
  }

  renderProductivityMainPanel (options, isPlannerAllowed) {
    return (
      <div className='headerpanel productivity'>
        <div className='row'>
          {this.renderProductivitySubPanel(options, isPlannerAllowed)}
        </div>
        <div className='col col1'>
          <ReportHeaderProductivityTotal stat={options.info} />
        </div>
        <div className='col col2'>
          <div className='graph'>
            <ReportHeaderProductivityGraphV2
              data={options.info.graphData}
              filterType={options.filterType}
              graphFromDate={options.graphFromDate}
              graphToDate={options.graphToDate}
              fromDate={options.fromDate}
              toDate={options.toDate}
            />
          </div>
        </div>
      </div>
    )
  }

  renderProductivityNormalHeader (options, isPlannerAllowed) {
    return (
      <div className='headerpanel productivity'>
        <div className='row'>
          {this.renderProductivitySubPanelNormal(options, isPlannerAllowed)}
        </div>
      </div>
    )
  }

  renderProductivitySubPanelNormal (options, isPlannerAllowed) {
    const {
      title,
      hasFilter,
      onShowSearch,
      hasStatInfo,
      onShowFilter,
      priceInfos,
      colType,
      hasObjectInfo,
      hasPriceInfo,
      onChangeFilter,
      filterTypes,
      filterType,
      fromDate,
      toDate,
      graphFromDate,
      graphToDate
    } = options

    const _className = classnames(
      'headerpanel',
      {
        hasobjectinfo: hasObjectInfo,
        haspriceinfo: hasPriceInfo || (priceInfos && priceInfos.length > 0),
        hasstatinfo: hasStatInfo,
        hasnormal: !isPlannerAllowed
      },
      colType
    )

    return (
      <div className={_className}>
        <div className='colleft'>
          <div className='icon-content layoutcol'>
            <IconButtonTheme icon='reports' size='big' type='invert' />
          </div>
          <div className='title'>
            {title && (
              <h2 className='headingtitle' onClick={onShowSearch}>
                {title}
              </h2>
            )}
            {hasFilter && (
              <IconButtonTheme
                className='filteractionbutton'
                size='normal'
                icon='filter'
                tooltip='common.list.tipFilterOpen'
                tooltipPosition='bottom'
                onClick={onShowFilter}
              />
            )}
            <ReportHeaderEmployeeProductivity
              filterTypes={filterTypes}
              filterType={filterType}
              fromDate={fromDate}
              toDate={toDate}
              graphFromDate={graphFromDate}
              graphToDate={graphToDate}
              onChangeFilter={onChangeFilter}
              isPlannerAllowed={isPlannerAllowed}
            />
          </div>
        </div>
      </div>
    )
  }

  renderProductivitySubPanel (options, isPlannerAllowed) {
    const {
      title,
      titleInfo,
      hasFilter,
      hasSearch,
      hasEdit,
      actions,
      onShowSearch,
      hasStatInfo,
      onShowFilter,
      onEdit,
      status,
      priceInfos,
      colType,
      hasObjectInfo,
      hasPriceInfo,
      statusLabel,
      onChangeFilter,
      filterTypes,
      filterType,
      fromDate,
      toDate,
      graphFromDate,
      graphToDate
    } = options

    let statusClass = ''
    if (status) {
      statusClass = `item status status_${status.toLowerCase()}`
    }
    const _className = classnames(
      'headerpanel',
      {
        hasobjectinfo: hasObjectInfo,
        haspriceinfo: hasPriceInfo || (priceInfos && priceInfos.length > 0),
        hasstatinfo: hasStatInfo
      },
      colType
    )

    return (
      <div className={_className}>
        <div className='colleft'>
          <div className='title'>
            {title && (
              <h2 className='heading2' onClick={onShowSearch}>
                {title}
              </h2>
            )}
            {hasFilter && (
              <IconButton
                className='filterbutton filterlinebutton'
                size='normal'
                canHover={false}
                tooltip='common.list.tipFilterOpen'
                tooltipPosition='right'
                onClick={onShowFilter}
              >
                <span className='fline flinetop' />
                <span className='fline flinemiddle' />
                <span className='fline flinebottom' />
              </IconButton>
            )}
            {hasEdit && (
              <IconButton
                icon='header-edit'
                size='small'
                canHover={false}
                className='filterbutton filteredit'
                tooltip='common.list.tipEditDetails'
                tooltipPosition='top'
                onClick={onEdit}
              />
            )}
            <ReportHeaderEmployeeProductivity
              filterTypes={filterTypes}
              filterType={filterType}
              fromDate={fromDate}
              toDate={toDate}
              graphFromDate={graphFromDate}
              graphToDate={graphToDate}
              onChangeFilter={onChangeFilter}
              isPlannerAllowed={isPlannerAllowed}
            />
          </div>
          {(titleInfo || statusLabel) &&
            this.renderTitleInfo(
              titleInfo,
              status,
              statusLabel,
              statusClass,
              ''
            )}
        </div>
        {(hasSearch ||
          actions.length > 0 ||
          (priceInfos && priceInfos.length > 0)) && (
          <div className='colright'>
            {(hasSearch || actions.length > 0) &&
              this.renderActionButtonGroup(hasSearch, onShowSearch, actions)}
            {this.renderPriceInfos(priceInfos, false)}
          </div>
        )}
      </div>
    )
  }

  renderTitleInfo (
    titleInfo,
    status,
    statusLabel,
    statusClass,
    titleInfoClass
  ) {
    return (
      <div className='titleinfo'>
        {statusLabel && (
          <span className={statusClass}>
            <IntlMessage ident={statusLabel} />
          </span>
        )}
        {titleInfo && (
          <div className={`item${titleInfoClass ? ' ' + titleInfoClass : ''}`}>
            {titleInfo}
          </div>
        )}
      </div>
    )
  }

  renderFilerPanel (options) {
    const {
      info,
      items,
      actions,
      onShowFilter,
      onClose,
      onDeleteFilter
    } = options

    return (
      <div className='headerpanel inside'>
        <div className='colleft'>
          <div className='filter'>
            {items.map((item, idx) => {
              const activeDateLabel =
                item.type === 'date'
                  ? this._getDateFitlerLabel(item.value, item.isDateRange)
                  : ''

              return item.type === 'label' ? (
                <span key={idx}>
                  <IntlMessage ident={item.label} />
                </span>
              ) : !item.value ||
                (item.type === 'date' && !activeDateLabel) ||
                (item.type === 'options' && item.value.length <= 0) ? (
                <span
                  key={idx}
                  className='filterlink'
                  onClick={_event =>
                    onShowFilter ? onShowFilter(item.ident) : null
                  }
                >
                  <IntlMessage ident={item.label} />
                </span>
              ) : (
                <span key={idx} className='filterlink'>
                  <span
                    className='title'
                    onClick={_event =>
                      onShowFilter ? onShowFilter(item.ident) : null
                    }
                  >
                    {item.type === 'options' ? (
                      item.value.join(', ')
                    ) : item.type === 'date' ? (
                      activeDateLabel
                    ) : (
                      <IntlMessage ident={item.value} />
                    )}
                    {item.value.ident === 'last-year' && item.subtitle
                      ? ' ' + item.subtitle
                      : ''}
                  </span>
                  <span
                    className='delete'
                    onClick={_event =>
                      onDeleteFilter ? onDeleteFilter(item.ident) : null
                    }
                  >
                    <i className='icon icon-header-close' />
                  </span>
                </span>
              )
            })}
          </div>
          <div className='filterinfo'>
            <IntlMessage ident={info} />
          </div>
        </div>
        <div
          className={`colright${actions && actions.length ? ' hasaction' : ''}`}
        >
          <div className='buttongroup'>
            <IconButton
              icon='header-search-close'
              className='filterbutton'
              size='big'
              canHover={false}
              onClick={onClose}
            />
            {actions &&
              actions.length > 0 &&
              actions.map((actOpt, idx) => (
                <IconButton
                  key={idx}
                  className='headeraction'
                  canHover={actOpt.canHover}
                  icon={actOpt.icon}
                  size={actOpt.size}
                  tooltip={actOpt.tooltip}
                  target={actOpt.target || ''}
                  tooltipPosition={actOpt.tooltipPosition}
                  href={actOpt.href || ''}
                  onClick={event =>
                    actOpt.onClick ? actOpt.onClick(event) : null
                  }
                />
              ))}
          </div>
        </div>
      </div>
    )
  }

  renderFilterListPanel (options) {
    const { items, active, onChange, onClose } = options
    return (
      <div key='option' className='headerpanel inside paneloptions'>
        <div className='colleft'>
          <div className='filteropts'>
            {items.map((item, idx) => (
              <span
                key={idx}
                className={item.ident === active ? 'active' : ''}
                onClick={event =>
                  onChange ? onChange(item.ident, event) : null
                }
              >
                <IntlMessage ident={item.label} />
              </span>
            ))}
          </div>
        </div>
        <div className='colright'>
          <div className='buttongroup'>
            <IconButton
              icon='common-success-tick'
              type='primary'
              canHover={false}
              className='filterbutton'
              size='big'
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    )
  }

  renderFilterTagPanel (options) {
    const {
      items,
      activeItems,
      keyword,
      placeholder,
      onSearch,
      onSelect,
      onClose,
      onRemoveTag
    } = options
    const countSeletedTags = activeItems ? activeItems.length : 0

    return (
      <div key='tag' className='headerpanel inside paneltag'>
        <div className='colleft'>
          <div className='filtersearch'>
            <Input
              name='keyword'
              type='text'
              maxLength={128}
              label={placeholder}
              className='headerfilterinput'
              value={keyword}
              autoFocus
              onChange={onSearch}
            />
            {this.renderSearchOptions(items, onSelect)}
          </div>
          <div className='filterinfo'>
            <IntlMessage ident='common.list.searchInfo' />
          </div>
          {countSeletedTags > 0 ? (
            <div className='filtertags'>
              {activeItems.map((tag, idx) => (
                <div key={idx} className='tag'>
                  <span className='title'>{tag.label}</span>
                  <span
                    className='delete'
                    onClick={_event =>
                      onRemoveTag ? onRemoveTag(tag.value) : null
                    }
                  >
                    <i className='icon icon-header-close' />
                  </span>
                  <span className='and'>
                    {idx === countSeletedTags - 2 ? (
                      <IntlMessage ident='common.list.andSplitter' />
                    ) : (
                      ','
                    )}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div className='filtermessage'>
              <IntlMessage ident='common.list.searchTagInfo' />
            </div>
          )}
        </div>
        <div className='colright'>
          <div className='buttongroup'>
            <IconButton
              icon='common-success-tick'
              type='primary'
              canHover={false}
              className='filterbutton'
              size='big'
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    )
  }

  renderFilerMultiSearchPanel (options) {
    const {
      items,
      activeItems,
      keyword,
      placeholder,
      onSearch,
      onSelect,
      onClose,
      onRemoveItem
    } = options
    const countSeletedItems = activeItems ? activeItems.length : 0

    return (
      <div key='tag' className='headerpanel inside paneltag'>
        <div className='colleft'>
          <div className='filtersearch'>
            <Input
              name='keyword'
              type='text'
              maxLength={128}
              label={placeholder}
              className='headerfilterinput'
              value={keyword}
              autoFocus
              onChange={onSearch}
            />
            {this.renderSearchOptions(items, onSelect)}
          </div>
          <div className='filterinfo'>
            <IntlMessage ident='common.list.searchInfo' />
          </div>
          {countSeletedItems > 0 ? (
            <div className='filtertags'>
              {activeItems.map((item, idx) => (
                <div key={idx} className='tag'>
                  <span className='title'>{item.label}</span>
                  <span
                    className='delete'
                    onClick={_event =>
                      onRemoveItem ? onRemoveItem(item) : null
                    }
                  >
                    <i className='icon icon-header-close' />
                  </span>
                  <span className='and'>
                    {idx === countSeletedItems - 2 ? (
                      <IntlMessage ident='common.list.andSplitter' />
                    ) : (
                      ','
                    )}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div className='filtermessage'>
              <IntlMessage ident='common.list.searchTagInfo' />
            </div>
          )}
        </div>
        <div className='colright'>
          <div className='buttongroup'>
            <IconButton
              icon='common-success-tick'
              type='primary'
              canHover={false}
              className='filterbutton'
              size='big'
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    )
  }

  renderFilerSearchPanel (options) {
    const { keyword, items, placeholder, onSearch, onSelect, onClose } = options
    return (
      <div key='search' className='headerpanel inside active'>
        <div className='colleft'>
          <div className='filtersearch'>
            <Input
              name='keyword'
              type='text'
              maxLength={128}
              label={placeholder}
              className='headerfilterinput'
              value={keyword}
              autoFocus
              onChange={onSearch}
            />
            {this.renderSearchOptions(items, onSelect)}
          </div>
          <div className='filterinfo'>
            <IntlMessage ident='common.list.searchInfo' />
          </div>
        </div>
        <div className='colright'>
          <div className='buttongroup'>
            <IconButton
              icon='common-success-tick'
              type='primary'
              canHover={false}
              className='filterbutton'
              size='big'
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    )
  }

  renderActionButtonGroup (hasSearch, onShowSearch, actions) {
    return (
      <div className='buttongroup'>
        {hasSearch && (
          <IconButton
            key='searchbutton'
            icon='header-search'
            size='normal'
            canHover={false}
            className='headeraction'
            tooltip='common.list.tipSearch'
            tooltipPosition='top'
            onClick={onShowSearch}
          />
        )}
        {actions.map((actOpt, idx) => (
          <IconButton
            key={idx}
            className='headeraction'
            canHover={actOpt.canHover}
            icon={actOpt.icon}
            size={actOpt.size}
            tooltip={actOpt.tooltip}
            type={actOpt.type || 'normal'}
            id={actOpt.id || ''}
            href={actOpt.href || ''}
            target={actOpt.target || ''}
            tooltipPosition={actOpt.tooltipPosition}
            onClick={actOpt.onClick || null}
          />
        ))}
      </div>
    )
  }

  renderSearchOptions (searchOptions, onSelectCallback = null) {
    if (!searchOptions || searchOptions.length <= 0) {
      return null
    }

    return (
      <div className='filtersearchlist'>
        {searchOptions.map((searchOpt, idx) => (
          <div
            key={idx}
            className='item'
            onClick={event =>
              onSelectCallback ? onSelectCallback(searchOpt, event) : null
            }
          >
            {searchOpt.label}
          </div>
        ))}
      </div>
    )
  }

  renderSearchKeywordPanel (options) {
    const { placeholder, keyword, actions, onSearch, onClose } = options
    return (
      <div className='headerpanel'>
        <div className='colleft'>
          <div className='filterseach'>
            <Input
              name='keyword'
              type='text'
              maxLength={128}
              label={placeholder}
              className='headersearch'
              value={keyword}
              autoFocus
              onBlur={event => (onSearch && !keyword ? onClose(event) : null)}
              onChange={onSearch}
            />
          </div>
        </div>
        <div className='colright'>
          <div className='buttongroup'>
            {this.renderCancelButton(onClose)}
            {actions.map((actOpt, idx) => (
              <IconButton
                key={idx}
                className='headeraction'
                canHover={actOpt.canHover}
                icon={actOpt.icon}
                size={actOpt.size}
                tooltip={actOpt.tooltip}
                tooltipPosition={actOpt.tooltipPosition}
                onClick={event =>
                  actOpt.onClick ? actOpt.onClick(event) : null
                }
              />
            ))}
          </div>
        </div>
      </div>
    )
  }

  renderCancelButton (onClose) {
    return (
      <IconButton
        key='searchclose'
        icon='header-search-close'
        size='normal'
        type='secondary'
        canHover={false}
        className='headeraction'
        tooltip='common.list.tipCancel'
        tooltipPosition='left'
        onClick={onClose}
      />
    )
  }

  renderFilerDateRangePanel (options) {
    const { isRange, filters, active, onChange, onClose } = options
    let fromDate = options.value ? new Date(options.value) : null
    let toDate = null
    if (isRange && options.value) {
      fromDate = options.value.from ? new Date(options.value.from) : null
      toDate = options.value.to ? new Date(options.value.to) : null
    }

    return (
      <div key='date' className='headerpanel inside paneldate active'>
        <div className='colleft'>
          <div className={`filterdaterange${isRange ? ' col2' : ''}`}>
            {isRange ? (
              <div className='daterange'>
                <div className='date'>
                  <FormDatePicker
                    icon='header-calendar'
                    placeholder='common.list.datePlaceholder'
                    size='big'
                    value={fromDate}
                    onChange={(date, _event) =>
                      onChange
                        ? onChange('custom', { from: date, to: toDate })
                        : null
                    }
                  />
                  <div className='filterinfo alignright'>
                    <IntlMessage ident='common.list.searchInfo' />
                  </div>
                </div>
                <div className='date'>
                  <FormDatePicker
                    icon='header-calendar'
                    placeholder='common.list.datePlaceholder'
                    size='big'
                    value={toDate}
                    onChange={(date, _event) =>
                      onChange
                        ? onChange('custom', { from: fromDate, to: date })
                        : null
                    }
                  />
                </div>
              </div>
            ) : (
              <div className='date'>
                <FormDatePicker
                  icon='header-calendar'
                  placeholder='common.list.datePlaceholder'
                  size='big'
                  value={fromDate}
                  onChange={(date, _event) =>
                    onChange ? onChange('custom', date) : null
                  }
                />
                <div className='filterinfo alignright'>
                  <IntlMessage ident='common.list.searchInfo' />
                </div>
              </div>
            )}
          </div>
          <div className='filteropts'>
            {filters.map((filterOption, idx) => (
              <span
                key={idx}
                className={filterOption.ident === active ? 'active' : ''}
                onClick={_event =>
                  onChange
                    ? onChange(
                        filterOption.ident,
                        filterOption.value,
                        filterOption.label
                      )
                    : null
                }
              >
                <IntlMessage ident={filterOption.label} />
                {filterOption.subtitle ? ' ' + filterOption.subtitle : ''}
              </span>
            ))}
          </div>
        </div>
        <div className='colright'>
          <div className='buttongroup'>
            <IconButton
              icon='common-success-tick'
              type='primary'
              canHover={false}
              className='filterbutton'
              size='big'
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    )
  }

  renderActionBar (options) {
    const {
      tabsLeft,
      tabsRight,
      actions,
      tabsRightActive,
      tabsLeftActive,
      actionActive,
      onTabsRightAction,
      onTabsLeftAction,
      onAction
    } = options
    return (
      <div className='actionbar'>
        {tabsLeft && tabsLeft.length > 0 && (
          <div className='colleft'>
            <div className='tabbar'>
              {tabsLeft.map((tabItem, idx) => (
                <div
                  key={idx}
                  className={`tabitem${
                    tabItem.ident === tabsLeftActive ? ' active' : ''
                  }${tabItem.iconLable ? ' haslabicon' : ''}`}
                  onClick={event =>
                    onTabsLeftAction
                      ? onTabsLeftAction(tabItem.ident, event)
                      : null
                  }
                >
                  <IntlMessage ident={tabItem.label} />
                  {tabItem.iconName && (
                    <span className='itemact'>
                      <span className='act'>
                        <i className={`icon icon-${tabItem.iconName}`} />
                      </span>
                      {tabItem.iconLable && (
                        <IntlMessage ident={tabItem.iconLable} />
                      )}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {((tabsRight && tabsRight.length > 0) ||
          (actions && actions.length > 0)) && (
          <div className='colright'>
            {actions && actions.length > 0 && (
              <div className='buttongroup'>
                {actions.map((actOpt, idx) => (
                  <IconButton
                    key={idx}
                    className={`headeraction alt${
                      actOpt.ident === actionActive ? ' active' : ''
                    }`}
                    canHover={actOpt.canHover}
                    icon={actOpt.icon}
                    size={actOpt.size}
                    tooltip={actOpt.tooltip}
                    tooltipPosition={actOpt.tooltipPosition}
                    onClick={event =>
                      onAction ? onAction(actOpt.ident, event) : null
                    }
                  />
                ))}
              </div>
            )}
            {tabsRight && tabsRight.length > 0 && (
              <div className='tabbar'>
                {tabsRight.map((tabItem, idx) => (
                  <div
                    key={idx}
                    className={`tabitem${
                      tabItem.ident === tabsRightActive ? ' active' : ''
                    }`}
                    onClick={event =>
                      onTabsRightAction
                        ? onTabsRightAction(tabItem.ident, event)
                        : null
                    }
                  >
                    <IntlMessage ident={tabItem.label} />
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    )
  }

  renderPriceInfos (infos, bPriceInfoProgress) {
    if (!infos || infos.length <= 0) {
      return null
    }

    if (bPriceInfoProgress) {
      return (
        <div className='headerinfolist headerinfolist_alt'>
          {infos.map((info, idx) => (
            <div key={idx} className='headerinfo headerinfo_price'>
              {info.tooltipInfos && info.tooltipInfos.length > 0 && (
                <IconButton
                  icon={`icon icon-${info.icon}`}
                  canHover={false}
                  className={
                    info.tooltipInfos.length > 0
                      ? `hashdrtooltip${info.tooltipInfos.length}`
                      : ''
                  }
                  stats={info.tooltipInfos}
                  size='small'
                  tooltipPosition='left'
                />
              )}
              <span className='infolabel'>
                <IntlMessage ident={info.label} />
              </span>
              <div className='content'>
                <h2
                  className={`infovalue${
                    info.percentage > 100 && info.showOverdue
                      ? ' infovalue_overspent'
                      : ''
                  }`}
                >
                  {info.value || 0}
                </h2>
              </div>
              <span className='infolabel'>
                <IntlMessage ident={info.subLabel} />
                &nbsp;
                <span className='value'>{info.subvalue || 0}</span>
              </span>
              <ProgressBar
                value={info.percentage}
                className='projectoverview'
                mode='determinate'
                max={100}
                buffer={100}
                type='linear'
                formatOverdue={!!info.showOverdue}
                secondary
                labelPosition='top'
              />
            </div>
          ))}
        </div>
      )
    } else {
      return (
        <div className='headerinfolist'>
          {infos.map((info, idx) => (
            <div key={idx} className='headerinfo headerinfo_price'>
              <div className='content'>
                <h2 className='infovalue'>
                  <span className='prefix'>{currency.symbol()}</span>
                  {info.value || 0}
                </h2>
              </div>
              <span className='infolabel'>
                <IntlMessage ident={info.label} />
                {info.subLabel ? ' ' + info.subLabel : ''}
              </span>
            </div>
          ))}
        </div>
      )
    }
  }

  renderObjectInfos (infos) {
    if (!infos || infos.length <= 0) {
      return null
    }

    return (
      <div className='headerinfolist object'>
        {infos.map((info, idx) => (
          <div key={idx} className='headerinfo headerinfo_object'>
            <span className='infolabel'>
              <IntlMessage ident={info.label} />
            </span>
            {info.isLink === undefined || !info.isLink ? (
              <h4 className='infovalue'>{info.value}</h4>
            ) : (
              <h4
                className='infovalue infovalue_link'
                onClick={event =>
                  info.onClick
                    ? info.onClick(info.pageIdent, info.param, event)
                    : null
                }
              >
                {info.value}
              </h4>
            )}
          </div>
        ))}
      </div>
    )
  }

  onEscKeyDown () {}

  showMessage (title, info, bSuccess) {
    const message = { title: title, info: info, bSuccess: bSuccess }
    this._message = message
    this.forceUpdate()

    if (this._messageTime) window.clearTimeout(this._messageTime)

    this._messageTime = window.setTimeout(() => {
      this._messageTime = null
      this._message = null
      this.forceUpdate()
    }, 3000)
  }

  /* Event Handlers */
  _onEscKey (event) {
    if (event.which === 27) {
      this.onEscKeyDown()
    }
  }

  /* Private functions */
  _getDateFitlerLabel (dateFilter, bRange) {
    if (!dateFilter || !dateFilter.value) return ''

    if (dateFilter.ident !== 'custom') {
      return dateFilter.label
        ? IntlUtil.convertMessage(dateFilter.label)
        : dateFilter.ident
    }

    if (!bRange) {
      return DateUtil.getDisplayDate(dateFilter.value)
    }

    if (dateFilter.value.from && dateFilter.value.to) {
      return (
        ` ${IntlUtil.convertMessage(
          'estimate.form.labelFrom'
        )} ${DateUtil.getDisplayDate(dateFilter.value.from)}` +
        ` ${IntlUtil.convertMessage(
          'estimate.form.labelUntil'
        )} ${DateUtil.getDisplayDate(dateFilter.value.to)}`
      )
    } else if (dateFilter.value.from) {
      return `${IntlUtil.convertMessage(
        'estimate.form.labelOn'
      )} ${DateUtil.getDisplayDate(dateFilter.value.from)}`
    } else if (dateFilter.value.to) {
      return `${IntlUtil.convertMessage(
        'estimate.form.labelOn'
      )} ${DateUtil.getDisplayDate(dateFilter.value.to)}`
    }

    return ''
  }
}

export default PageHeaderBase
